import {
  connectFirestoreEmulator,
  getFirestore,
  initializeFirestore,
} from "firebase/firestore";
import { config } from "../../clientConfig";
import { firebaseApp } from "./firebase";

const firestoreInit = () => {
  if (config.payment.serverMode != "localDev") return getFirestore();
  else {
    const db = initializeFirestore(firebaseApp, {
      experimentalForceLongPolling: true,
    });
    try {
      connectFirestoreEmulator(db, "localhost", 8080);
      console.log("Local Firestore");
    } catch (e) {}

    // await enableIndexedDbPersistence(db);
    return db;
  }
};
//TODO: light?
var _firestore = firestoreInit();

export const firestore = _firestore;
